export default __webpack_public_path__ + "assets/puertoMorelos.31d664ed.jpg";